// src/components/Workimg.jsx
import React from 'react';
import './Workimg.css'; // Assuming you have a separate CSS file for styles

const projects = [
  {
    image: '/assets/work/mcd.jpeg',
    title: "McDonald's",
    subtitle: 'Ground up & major remodels',
    description: "Rubix has been structural engineer-of-record on hundreds of McDonald's projects across the US. Our designs have included multiple structural systems for varying load demands and soil conditions."
  },
  {
    image: '/assets/work/chipotle.jpeg',
    title: 'Chipotle',
    subtitle: 'Ground up & major remodels',
    description: 'Rubix has helped Chipotle adapt their structural designs for projects around the southwest, utilizing structural systems in concrete, steel, and lumber. We have worked with Chipotle on challenging renovations where existing structural slabs and shear walls needed to be modified.'
  },
  {
    image: '/assets/work/starbucks.jpg',
    title: 'Starbucks',
    subtitle: 'Ground up & major remodels',
    description: 'Since 2011, Rubix has helped Starbucks expand their presence across the US with elegant, efficient, and affordable designs. From high snow loads in the mountains of Colorado, to highly expansive soils around Texas - our designs have stood the test of time, and the confidence placed in us by our clients.'
  },
  {
    image: '/assets/work/Take5.jpg',
    title: 'Take 5',
    subtitle: 'Car wash & Oil Change',
    description: 'Rubix came up with structural designs for car wash and oil change outlets for the fast-growing Take 5 brand from Texas to Minnesota. Design challenges on these projects include vehicle loads, steep slab slopes, and conditioned + unconditioned spaces.'
  },
  {
    image: '/assets/work/tjmaxx.jpeg',
    title: 'TJ Maxx, Homegoods & Marshall’s',
    subtitle: 'Ground up & remodels',
    description: 'Rubix has completed structural designs and construction administration on dozens of TJ Maxx brand projects across the US. From storefront facade renovations with clear spans over 70 feet, to HVAC equipment and shear wall modifications, Rubix has risen to meet multiple on-site challenges.'
  }
];

const Workimg = () => (
  <section id="work-examples" className="py-16 mt-20">
    <div className="border-t border-black mt-8 mx-auto border-line" style={{ width: '980px', transformOrigin: 'center' }}></div>
    <div className="container mx-auto">
      {projects.map((project, index) => (
        <div key={index}>
          <div className={`flex items-center ${index % 2 !== 0 ? 'flex-row-reverse' : ''} mb-8 project-container`}>
            <img src={project.image} alt={project.title} className="object-cover project-image" />
            <div className="text-left p-10 project-details" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'lighter' }}>
              <h3 className="text-xl font-bold" style={{ fontSize: '30px', fontFamily: 'Montserrat, sans-serif', fontWeight: 'lighter' }}>{project.title}</h3>
              <h4 className="text-md font-semibold mb-10" style={{ fontSize: '25px', marginTop: '12px', fontFamily: 'Montserrat, sans-serif', fontWeight: 'lighter' }}>{project.subtitle}</h4>
              <p className="text-md" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 'lighter' }}>{project.description}</p>
            </div>
          </div>
          <div className="border-t border-black mt-8 mx-auto border-line" style={{ width: '980px', transformOrigin: 'center' }}></div>
        </div>
      ))}
    </div>
  </section>
);

export default Workimg;
